export default __webpack_public_path__ + "static/create-playlist-light-mode-70f9abddc6deb2293a1d4cd19d92efba.mp4";